import React, {PropTypes} from "react"

const Price = ({children = 0, currency = "€", className= "price"}) => {
   if (typeof children !== "number") console.warn("Invalid Price: Price must be a number. Instead got:", typeof children, children)
   let price = children || 0
   price     = parseFloat(Math.round(price * 100) / 100).toFixed(2).replace(".", ",")
   return <span className={className}>{price}&nbsp;{currency}</span>
}

Price.propTypes = {
   children: PropTypes.number,
   currency: PropTypes.string
}

export default Price



// WEBPACK FOOTER //
// ./src/components/Price/Price.js